// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__x6F91","checkboxWrapper":"Checkbox_checkboxWrapper__QTFNA"};